import type { SxProps } from '@mui/material';
import type { ImageGalleryFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import type { FlagProps } from '@packages/shared';
import { Box, Flag, Image, Stack } from '@packages/shared';
import type { FC } from 'react';

export type ImageGalleryFlagsProps = {
  flags: ImageGalleryFragmentFragment['additionalFlags'];
};

const stackStyle: SxProps = {
  touchAction: 'none',
  position: 'absolute',
  bottom: 'calc(1rem + 96px)',
  left: 1.5,
};

const imageContainerStyle: SxProps = {
  maxWidth: '11.25rem',
  width: '11.25rem',
  maxHeight: '3rem',
  height: '3rem',
  position: 'relative',
  '> img': {
    objectFit: 'contain',
    height: 'auto !important',
    width: '100%',
  },
};

export const ImageGalleryFlags: FC<ImageGalleryFlagsProps> = ({ flags }) => (
  <Stack sx={stackStyle} gap={1} alignItems="flex-start">
    <div id="dy_info_bigpicture_dv" />
    {flags?.map(({ src, text, type }, index) =>
      /* custom attributes (images) are not renderer as flags, but as plain images instead */
      type !== 'CUSTOM' ? (
        <Flag
          key={text ?? index.toString()}
          type={type.toLowerCase() as FlagProps['type']}
          text={text ?? ''}
        />
      ) : (
        <Box key={text ?? index.toString()} sx={imageContainerStyle}>
          <Image src={src.concat('.png') ?? ''} alt={text ?? ''} fill />
        </Box>
      ),
    )}
  </Stack>
);
